




































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { listClientUnitProductsOptions } from '@/services/client-unit';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
  },
})
export default class ClientUnitProducts extends BaseComponent {
  @Prop()
  public value: any[];

  @Prop({
    default: false,
  })
  public isEdit: boolean;

  @Prop()
  public unit: any;

  private products: any[] = [];
  private productsSelec: any[] = [];
  private productAdd: any = null;
  private loading: boolean = false;
  public headers: any = [    
    { text: 'Código', value: 'codigo', sortable: true },
    { text: 'Descrição', value: 'descricao', align: 'left', sortable: true },
    { text: 'Grupo', value: 'grupo', align: 'left', sortable: true },
    { text: 'Subgrupo', value: 'subgrupo', align: 'left', sortable: true },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];

  @Watch('value')
  private onValueChange() {
    this.productsSelec = Object.assign([], this.value);
  }

  private onProdsChange() {
    this.$emit('input', this.productsSelec);
  }

  public beforeMount(): void {
    this.getProducts();
  }

  @Watch('unit')
  onUnitChange() {
    this.getProducts();
  }

  private getProducts(): void {
    this.loading = true;
    listClientUnitProductsOptions().subscribe(
      (data) => {
        this.products = data.map((item) => {
          return {
            ...item,
            descricaofull: item.codigo + ' - ' + item.descricao,
          };
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  private getAvailableItems(): any[] {
    return this.products.filter((p) => !this.productsSelec.filter((sp) => sp != null && sp.id == p.id).length);
  }

  private addProd() {
    this.productsSelec.push(this.productAdd);
    setTimeout(() => {
      this.onProdsChange();
      this.productAdd = null;      
    }, 200);
  }

  private deleteProd(prod) {
    this.productsSelec.splice(this.productsSelec.indexOf(prod), 1);
    setTimeout(() => {
      this.onProdsChange();      
    }, 200);
  }

}
